import { useState } from "react";

export default function FilterTags({ filters, onChange, placeholder = "Voeg filter toe…" }) {
  const [input, setInput] = useState("");

  const add = () => {
    const val = input.trim();
    if (!val || filters.includes(val)) return;
    onChange([...filters, val]);
    setInput("");
  };

  const remove = (item) => {
    onChange(filters.filter(f => f !== item));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      add();
    }
  };

  return (
    <div className="filter-tags">
      {filters.map(f => (
        <span key={f} className="filter-tag">
          {f}
          <button
            className="filter-tag-remove"
            onClick={() => remove(f)}
            aria-label={`Remove ${f}`}
          >
            ×
          </button>
        </span>
      ))}
      <div className="filter-tag-input-row">
        <input
          className="filter-tag-input"
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
        />
        <button className="filter-tag-add" onClick={add} aria-label="Add filter">+</button>
      </div>
    </div>
  );
}
